import { Badge } from "@/components/ui/badge";
import { isDiscountActive, getEffectivePrice, formatPrice, type DiscountInfo } from "@/lib/discount-utils";
import { cn } from "@/lib/utils";

interface DiscountPriceProps {
  originalPriceCents: number;
  currency?: string;
  discountInfo: DiscountInfo;
  className?: string;
  showBadge?: boolean;
}

export function DiscountPrice({ 
  originalPriceCents, 
  currency = "EUR", 
  discountInfo, 
  className,
  showBadge = true 
}: DiscountPriceProps) {
  const hasActiveDiscount = isDiscountActive(discountInfo);
  const effectivePrice = getEffectivePrice(originalPriceCents, discountInfo);

  if (!hasActiveDiscount) {
    return (
      <div className={cn("flex items-center gap-2", className)}>
        <span className="font-semibold text-foreground">
          {formatPrice(originalPriceCents, currency)}
        </span>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="flex flex-col">
        <span className="text-sm text-muted-foreground line-through">
          {formatPrice(originalPriceCents, currency)}
        </span>
        <span className="font-semibold text-destructive">
          {formatPrice(effectivePrice, currency)}
        </span>
      </div>
      {showBadge && discountInfo.discount_percentage && (
        <Badge variant="destructive" className="text-xs">
          -{discountInfo.discount_percentage}%
        </Badge>
      )}
    </div>
  );
}